import { render, staticRenderFns } from "./ListaDeudas.vue?vue&type=template&id=0d9f01d3"
import script from "./ListaDeudas.vue?vue&type=script&lang=js"
export * from "./ListaDeudas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports